const url = '/incomeAccounts';
const Provider = 'IncomeAccounts';
const dbModel = 'IncomeAccounts';

export { url, Provider, dbModel };
